import { createContext } from 'react';

const BasicsContext = createContext();
export default BasicsContext;
